import React, { useEffect, useState } from 'react';
import { accessService } from '../../services/central-api/access';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';


interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    actingBodyId: number | null;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
    includeAllOption?: boolean;
}

function ActingBodiesCommandDropdown({ value, setValue, actingBodyId, zIndex, labelStyle, viewStyle, label, includeAllOption = false }: Props) {
    const [selectableActingBodyCommands, setSelectableActingBodyCommands] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodyCommands({ actingBodyId }: { actingBodyId: number; }) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);

            if (!actingBody.actingBodyCommands) {
                setSelectableActingBodyCommands([]);
            } else {
                setSelectableActingBodyCommands([
                    ...(includeAllOption ? [{ value: 0, label: translate('masculineAll') }] : []),
                    ...actingBody.actingBodyCommands.map((role) => {
                        return {
                            value: role.id || 0,
                            label: role.name
                        };
                    })
                ]);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getActingBodyCommands({ actingBodyId });
        }
    }, [actingBodyId]);

    return (
        <FilterDropdown
            label={label ?? translate('command')}
            items={selectableActingBodyCommands}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}

export default ActingBodiesCommandDropdown;
